import React from 'react';

import Masterclass from './Masterclass/Masterclass';

import { ReactComponent as LinkArrow } from 'assets/icons/link_arrow.svg';

import styles from './Masterclasses.module.scss';

const Masterclasses = ({
    data,
    selectedCategory,
    setSelectedCategory,
    loadMoreData,
    limit,
    noMoreData,
    showRegisterModal,
    user,
    search,
}) => {
    const items =
        selectedCategory === data.target_type
            ? data.items
            : data.items.slice(0, 2);

    return (
        <div
            className={[
                styles.masterclasses,
                data ? styles.animate : null,
            ].join(' ')}
        >
            <div className={styles.header}>
                <div className={styles.header_title}>
                    <h2>
                        {data && data.item_count}{' '}
                        {data.item_count !== 1
                            ? 'Masterclass episodes'
                            : 'Masterclass episode'}
                    </h2>
                    {selectedCategory !== data.target_type && (
                        <span
                            onClick={() =>
                                setSelectedCategory(data.target_type)
                            }
                            id="open"
                        >
                            View all <LinkArrow />
                        </span>
                    )}
                </div>
            </div>
            <div className={styles.content}>
                {items &&
                    items.map((el) => {
                        return (
                            <Masterclass
                                search={search}
                                user={user}
                                key={el.id}
                                data={el}
                                showModal={showRegisterModal}
                            />
                        );
                    })}
            </div>
            {selectedCategory === data.target_type &&
                !(noMoreData || (items && items.length >= data.item_count)) && (
                    <button
                        type="button"
                        onClick={loadMoreData}
                        className={styles.more_btn}
                        disabled={
                            noMoreData ||
                            (items && items.length >= data.item_count)
                        }
                    >
                        Show me more
                    </button>
                )}
        </div>
    );
};

export default Masterclasses;
